const unitMappings: Record<
  string,
  { "pt-BR": string; en: string; es: string; variables: number[] }
> = {
  Knots: {
    "pt-BR": "Nós",
    en: "Knots",
    es: "Nudos",
    variables: [7, 2, 21, 62, 69, 71, 89, 91, 99],
  },
  Degrees: {
    "pt-BR": "Graus",
    en: "Degrees",
    es: "Grados",
    variables: [8, 5, 3, 22, 63, 85, 86, 90],
  },
  Meters: {
    "pt-BR": "Metros",
    en: "Meters",
    es: "Metros",
    variables: [4, 1, 11, 40, 80, 77, 36, 97, 98],
  },
  Seconds: {
    "pt-BR": "Segundos",
    en: "Seconds",
    es: "Segundos",
    variables: [6, 83, 84],
  },
  "mm/h": {
    "pt-BR": "mm/h",
    en: "mm/h",
    es: "mm/h",
    variables: [9, 94, 95],
  },
  "%": {
    "pt-BR": "%",
    en: "%",
    es: "%",
    variables: [61, 88, 96, 100, 101, 102, 103, 104, 105, 108, 109, 116, 122],
  },
  hPa: {
    "pt-BR": "hPa",
    en: "hPa",
    es: "hPa",
    variables: [10],
  },
  "kW/m": {
    "pt-BR": "kW/m",
    en: "kW/m",
    es: "kW/m",
    variables: [87],
  },
  "°C": {
    "pt-BR": "°C",
    en: "°C",
    es: "°C",
    variables: [60, 23],
  },
  "flash/h": {
    "pt-BR": "raios/h",
    en: "flash/h",
    es: "flash/h",
    variables: [93],
  },
  mm: {
    "pt-BR": "mm",
    en: "mm",
    es: "mm",
    variables: [110, 111, 112, 113, 114, 115, 123],
  },
  "-": {
    "pt-BR": "-",
    en: "-",
    es: "-",
    variables: [120, 121, 124],
  },
  "m²": {
    "pt-BR": "m²",
    en: "m²",
    es: "m²",
    variables: [117, 118, 119],
  },
};

export const getUnitsMeasurement = (
  environmentalVariableId: number,
  lang: "pt-BR" | "en" | "es" = "en",
): string => {
  for (const mapping of Object.values(unitMappings)) {
    if (mapping.variables.includes(environmentalVariableId)) {
      return mapping[lang];
    }
  }
  return "";
};
